import React from 'react';
import { Grid, InputAdornment } from '@material-ui/core';
import { useLocale, useAssetStatus } from 'hooks';
import dayjs from 'dayjs';

import { Asset } from 'hooks/useAssets/useAssets.types';
import { DataGrid, DataGridCell } from 'ui';
import { DataGridColumnConfig } from 'ui/dataGrid/DataGrid.types';
import { SearchIcon, FactoryIcon, CalendarIcon, InstallerIcon } from 'ui/icons';
import { GenericField } from 'form/fields';
import { AutosaveForm } from '../../../form/autosaveForm/AutosaveForm';

import { useStyles } from './UsageReport.styles';
import { UsageReportProps } from './UsageReport.types';

export const UsageReport = ({ batteryList, onFiltersChange }: UsageReportProps) => {
  const classes = useStyles();
  const { formatMessage } = useLocale();
  const { getIcon } = useAssetStatus();

  const columnsConfig: DataGridColumnConfig<Asset>[] = [
    {
      name: 'status',
      labelId: 'usage_report.grid.status',
      formatCell: data => {
        return <DataGridCell icon={getIcon(data.status)} />;
      },
    },
    {
      name: 'id',
      labelId: 'usage_report.grid.serial_number',
      formatCell: data => {
        return <DataGridCell title={data.id} description={data.transactionHash} />;
      },
    },
    {
      name: 'issued',
      labelId: 'usage_report.grid.issued',
      formatCell: data => {
        return (
          <DataGridCell
            title={dayjs(data.dateOfIssue).format('YYYY-MM-DD')}
            description={data.transactionHash}
            icon={<CalendarIcon />}
          />
        );
      },
    },
    {
      name: 'manufacturer',
      labelId: 'usage_report.grid.manufacturer',
      formatCell: data => {
        return (
          <DataGridCell
            title={data.manufacturer?.name}
            description={data.transactionHash}
            icon={<FactoryIcon color="error" />}
          />
        );
      },
    },
    {
      name: 'installer',
      labelId: 'usage_report.grid.installer',
      formatCell: data => {
        return (
          <DataGridCell title={data.installer?.name} description={data.transactionHash} icon={<InstallerIcon />} />
        );
      },
    },
    {
      name: 'name',
      labelId: 'usage_report.grid.battery_model',
    },
    {
      name: 'manufacturerSN',
      labelId: 'usage_report.grid.manufacturer_sn',
    },
  ];

  return (
    <>
      <AutosaveForm
        onSubmit={onFiltersChange}
        defaultValues={{
          search: '',
        }}
      >
        <Grid container className={classes.filters}>
          <Grid item xs={3}>
            <GenericField
              name="search"
              placeholder={formatMessage({ id: 'batteries_filters.search_placeholder' })}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
      </AutosaveForm>
      <DataGrid<Asset> columnsConfig={columnsConfig} data={batteryList} />
    </>
  );
};
